/**
 * Build-time configuration. Tokens come from `.env.local` (see `.env.example`).
 *
 * The Mapbox token is a *public* token (pk.*) and is necessarily visible in the
 * bundle - that is how every browser map works. Protect it with a URL
 * restriction in the Mapbox dashboard rather than trying to hide it.
 */

export const APP_VERSION = '1.10';

export const MAPBOX_TOKEN: string = import.meta.env.VITE_MAPBOX_TOKEN ?? '';
export const SPOTIFY_CLIENT_ID: string = import.meta.env.VITE_SPOTIFY_CLIENT_ID ?? '';

export const hasMapbox = (): boolean => /^pk\./.test(MAPBOX_TOKEN);
export const hasSpotify = (): boolean => SPOTIFY_CLIENT_ID.length > 0;

/** Bias search and routing to Thailand. */
export const REGION = {
  country: 'th',
  /** Bangkok, used only until the first GPS fix arrives. */
  fallbackCenter: [100.5018, 13.7563] as [number, number],
  language: 'en',
} as const;

export const MAP_STYLES = {
  night: 'mapbox://styles/mapbox/navigation-night-v1',
  day: 'mapbox://styles/mapbox/navigation-day-v1',
} as const;
